module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask",
    attrs: {
      "transition": "modal"
    },
    on: {
      "click": _vm.hide
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container modal-transition-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "btn btn-full-width btn-primary modal-default-button",
    attrs: {
      "disabled": _vm.disableOkBtn
    },
    on: {
      "click": _vm.ok
    }
  }, [(_vm.okBtnText) ? [_vm._v(_vm._s(_vm.okBtnText))] : [_vm._v(_vm._s(_vm.$t('ok')) + " | " + _vm._s(_vm.okBtnText))]], 2), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9f84c22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/generic/Modal.vue
// module id = 1068
// module chunks = 1